import { Environment } from './environment.model';

export const environment: Environment = {
    production: true,
    environment: 'staging',
    accountAppUrl: 'https://account-staging.viessmann-climatesolutions.com',
    baseApiUrl: 'https://api-staging.viessmann-climatesolutions.com',
    baseUrl: 'https://api-staging.viessmann-climatesolutions.com',
    partnerPortalBaseUrl: 'https://partnerportal-staging.viessmann-climatesolutions.com',
    translationsBaseUrl: 'https://api-staging.viessmann-climatesolutions.com/translations/v2',
    apiKey: '68ddc22a-29e7-4d7b-b0fa-57112c38b02c',
    phraseappProjectId: {
        homePlanner: '8e2aa2a65cc63ba26a928b36582552c8',
        globalHeader: '30b1afd8a62ba6728e53abffe9101eb2',
        designSystemWeb: 'ec38b083a23c58c604a49d7f443dd7f2',
        flows: '5cfb7f9a03a8d6fba82d29aa840b7715'
    },
    authConfig: {
        issuer: 'https://iaml2.viessmann-climatesolutions.com',
        loginUrl: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/authorize',
        logoutUrl: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/sso/logout',
        tokenEndpoint: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/token',
        userinfoEndpoint: 'https://iaml2.viessmann-climatesolutions.com/idp/v2/tokeninfo',
        redirectUri: 'https://home-planner-staging.viessmann-climatesolutions.com/utils',
        clientId: 'd9d1488a70fef679d663ab400e210c31',
        postLogoutRedirectUri: '',
        responseType: 'code',
        scope: 'Internal',
        oidc: false,
        clockSkewInSec: 0
    },
    vapi: {
        baseUrl: 'https://api-staging.viessmann-climatesolutions.com',
        entrypoint: '/planning-projects/v1'
    }
};
